import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../shared/services/auth.service';
import { BrowserStorageService } from '../shared/services/common/browser-storage.service';

export const authGuard: CanActivateFn = (route, state) => {
  const _storage = inject(BrowserStorageService);
  const _auth = inject(AuthService);
  const _router = inject(Router);
  if (_storage.getCookie('authToken')) {
    if (_auth.getSignUpStep() < 3) {
      _auth.profileRouting();
    }
    return true;
  }
  _router.navigate(['/']);
  return false;
};

export const authPagesGuard: CanActivateFn = (route, state) => {
  const _storage = inject(BrowserStorageService);
  const _auth = inject(AuthService);
  if (_storage.getCookie('authToken')) {
    _auth.profileRouting();
    return false;
  }
  return true;
};
